import { render } from "./PartnerView.vue?vue&type=template&id=8b23ea88&scoped=true"
import script from "./PartnerView.vue?vue&type=script&lang=js"
export * from "./PartnerView.vue?vue&type=script&lang=js"

import "./PartnerView.vue?vue&type=style&index=0&id=8b23ea88&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b23ea88"]])

export default __exports__